var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_22786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5459 8.12498C6.81431 8.48381 7.15675 8.78072 7.54999 8.99557C7.94324 9.21041 8.37809 9.33818 8.82506 9.37019C9.27202 9.4022 9.72064 9.33771 10.1405 9.18109C10.5603 9.02448 10.9416 8.7794 11.2584 8.46248L13.1334 6.58748C13.7026 5.9981 14.0176 5.20871 14.0105 4.38935C14.0034 3.56998 13.6747 2.7862 13.0953 2.2068C12.5159 1.6274 11.7321 1.29874 10.9128 1.29162C10.0934 1.2845 9.30403 1.59948 8.71465 2.16873L7.63965 3.23748",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04578 6.87477C8.77737 6.51594 8.43493 6.21904 8.04169 6.00419C7.64844 5.78934 7.21359 5.66158 6.76662 5.62957C6.31966 5.59756 5.87104 5.66205 5.45119 5.81866C5.03134 5.97528 4.65008 6.22036 4.33328 6.53727L2.45828 8.41227C1.88904 9.00166 1.57405 9.79104 1.58117 10.6104C1.58829 11.4298 1.91695 12.2136 2.49635 12.793C3.07575 13.3724 3.85954 13.701 4.6789 13.7081C5.49827 13.7153 6.28765 13.4003 6.87703 12.831L7.94578 11.7623",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_22786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.295898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6f625ba86c2e2670995cb34788c6abac.svg";
export { ForwardRef as ReactComponent };